/**
 * Human-readable "as of" labels for chat widget provenance lines (RAI-1080).
 *
 * Widget payloads carry machine timestamps (full ISO like
 * "2026-07-19T15:05:17.207Z" or date-only "2026-07-19"). Clients must never
 * render those raw. This is the single formatter both mobile and web widget
 * cards use, so the presentation cannot drift per surface.
 */

const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

export function formatChatV8AsOfLabel(value: string): string {
  const trimmed = value.trim();

  // Date-only strings must not round-trip through Date's UTC-midnight
  // parsing, which can shift the calendar day in western timezones.
  const dateOnly = DATE_ONLY_PATTERN.exec(trimmed);
  if (dateOnly) {
    const [, year, month, day] = dateOnly;
    const date = new Date(Number(year), Number(month) - 1, Number(day));
    if (Number.isNaN(date.getTime())) return trimmed;
    return formatDate(date);
  }

  const parsed = new Date(trimmed);
  if (Number.isNaN(parsed.getTime())) return trimmed;
  return formatDate(parsed);
}

export function formatChatV8ChartAsOfLine(value: string): string {
  const label = formatChatV8AsOfLabel(value);
  return label ? `As of ${label}` : "As of";
}

function formatDate(date: Date): string {
  return new Intl.DateTimeFormat("en-US", {
    day: "numeric",
    month: "short",
    year: "numeric",
  }).format(date);
}
